/**
 *  All api related to Support Ticket
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function createBackInStockNotifications(backInStockNotification) {
  // {
  //   "back_in_stock_notification": {
  //     "store_id": 6,
  //     "target_item_type": "Sku",
  //     "target_item_id": "105",
  //     "all_store": false,
  //     "frontend_url_params": {
  //       "testing": "testing"
  //     }
  //   }
  // }

  const payload = {
    data: {
      backInStockNotification,
    },
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createBackInStockNotifications',
    () => source.cancel('createBackInStockNotifications: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `back_in_stock_notifications`,
      method: 'post',
      data: payload,
      cancelToken: source.token,
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      backInStockNotifications: data.backInStockNotifications
    }))
}

export function fetchBackInStockNotifications(options) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchBackInStockNotifications',
    () => source.cancel('fetchBackInStockNotifications: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'back_in_stock_notifications',
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      backInStockNotifications: data.backInStockNotifications,
      pagination: data.backInStockNotificationsPagination,
      next: _.get(data, 'backInStockNotificationsPagination.nextPage') > page
        ? () => fetchBackInStockNotifications({ page: page + 1, ...others })
        : null,
      count: _.get(data, 'backInStockNotificationsPagination.totalCount')
    }))
}

export function deleteBackInStockNotifications(id) {
  const payload = {
    data: {
      backInStockNotification: {}
    }
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'deleteBackInStockNotifications',
    () => source.cancel('deleteBackInStockNotifications: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `back_in_stock_notifications/${id}`,
      method: 'delete',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
}
